'use client'

import {
  Box,
  Text,
  Center,
  Flex,
  Divider,
  chakra,
  Grid,
  GridItem,
  Container,
  Heading,
  Stack,
  Image,
  List,
  ListItem,
  ListIcon,

} from '@chakra-ui/react'
import { FaMailBulk, FaRegChartBar, FaLaptopCode, FaAngleDoubleUp } from 'react-icons/fa';
import { IoShareSocial } from 'react-icons/io5'
import { COLORS } from '../../../colors';
import { CheckCircleIcon } from '@chakra-ui/icons'



export default function Features() {
  return (
    <Stack minH={'100vh'} direction={{ base: 'column', md: 'row' }} fontFamily={"Montserrat"} bg={COLORS.brand4}>
          <Flex flex={1}>
      <Image
        alt={'Login Image'}
        objectFit={'cover'}
        src={
         "/metodologia2.JPG"
        }
      />
    </Flex>
    <Flex p={8} flex={1} align={'top'} justify={'center'}  >
      <Stack spacing={20} w={'full'} maxW={'lg'} vertical-align={'top'}>
        <Heading textAlign={"center"} as="h2" size="xl" mt={6} mb={2} fontFamily={"Montserrat"}  >Nuestra metodología</Heading>
        <List spacing={8}>
          <ListItem>
            <ListIcon as={CheckCircleIcon} color={COLORS.brand1} />
            Nuestro método de enseñanza es un método propio, el cual hemos ido desarrollando, mejorando y adaptando a las nuevas necesidades
        </ListItem>
        <ListItem>
            <ListIcon as={CheckCircleIcon} color={COLORS.brand1} />
            El método es fundamentalmente práctico y está basado en la comunicación oral.
        </ListItem>
        <ListItem>
            <ListIcon as={CheckCircleIcon} color={COLORS.brand1} />
            La finalidad del método es el que alumno razone, piense y se comunique en el idioma, para ello introducimos situaciones reales y útiles para el alumno.
        </ListItem>
      </List>
      </Stack>
    </Flex>
  </Stack>
  )
}
